import React, { Component } from 'react';

import {
    Row, Col,
    Modal, ModalHeader, ModalBody, ModalFooter,
    Form, FormGroup, Label, Input,
    Alert, Collapse
} from 'reactstrap';
import moment from 'moment';
import Button from 'reactstrap/lib/Button';
import BoxConfigurationReservation from './BoxConfigurationReservation';
import QuickOrderModal from './QuickOrderModal';


class BoxConfiguration extends Component {
    state = {
        box_configuration: {},
        available_orders: [],
        openOrderModal: false,
        openApplyOrderModal: false,
        selectedOrder: null,
        applyOrderQty: 1,
        applyOrderError: "",
        applyOrderSuccess: false,
        alertMsg: "",
        showAlert: false,
        rating: 0,
        comment: "",
        qty: 1,
        separateProducts: false,
        readyToOrder: false,
        formSubmitted: false,
        showWarning: false,
        showSuccess: false,
        successMsg: "",
        warningMsg: "",
        orders_needing_items: [],
        showRequiredProducts: false
    }

    constructor(props) {
        super(props)

        if (this.props.box_configuration) {
            this.state.box_configuration = this.props.box_configuration;
            this.state.available_orders = this.props.box_configuration.available_orders.filter(order => order.meets_requirements);
            // this.state.orders_needing_items = this.props.box_configuration.available_orders.filter(order => !order.meets_requirements);
        }
        this.os = this.props.os;
    }

    componentDidMount = () => {
        // this.getValidation(1);
    }

    checkQty = async (e) => {
        this.setState({ qty: e.target.value });
        // CAll API box_configurations/id/validate to check if the qty is valid
        // if (e.target.value > 0) {
        //     this.getValidation(e.target.value);
        // }
    }

    getValidation = async (qty, order_number) => {
        let token = JSON.parse(localStorage.getItem("token"));
        this.os.validateBoxConfiguration(token, this.state.box_configuration.id, qty, order_number).then((result) => {

            if (result.meets_requirements === false) {
                // if available_orders is not empty  list required products of each available order with each product and its required qty and button to order
                // if (result.available_orders.length > 0) {
                //     this.setState({ available_orders: result.available_orders });
                // }
                var alertMsg = result.required_products
                    .filter((product) => product.required_qty > 0 && product.is_placeholder === false)
                    .map((product) => { return `${product.sku}, ${product.required_qty}` })

                    alertMsg.unshift("Products Needed");
                this.setState({ showWarning: true, warningMsg: alertMsg.join('\n') });
            } else {
                this.setState({ showWarning: false, warningMsg: "", readyToOrder: true });
            }
        }).catch((error) => {
            console.log('error', error);
            this.setState({
                showAlert: true,
                alertMsg: "Error validating box_job " + error
            })
        })

    }

    applyOrder = async (order_id, quantity = 1) => {
        let token = JSON.parse(localStorage.getItem("token"));
        this.setState({ applyOrderError: "", applyOrderSuccess: false });

        this.os.createBoxJob(token, this.state.box_configuration.id, order_id, quantity).then((result) => {
            if (result.error) {
                this.setState({
                    applyOrderError: "Error creating box_job: " + result.error
                })
            } else {
                this.setState({
                    applyOrderError: "",
                    openApplyOrderModal: false,
                    applyOrderSuccess: true,
                    selectedOrder: null,
                    applyOrderQty: 1
                });
                // Reload the page with success message
                setTimeout(() => {
                    window.location.reload();
                }, 1500);
            }
        }).catch((error) => {
            this.setState({
                applyOrderError: "Error creating Box Job: " + error.message
            })
        })
    }

    reserveBoxConfiguration = async () => {
        // Directly reserve - confirmation is now handled by checkbox in the modal
        let token = JSON.parse(localStorage.getItem("token"));
        this.os.reserveBoxConfiguration(token, this.state.box_configuration.id, this.state.qty).then((result) => {
            if (result.error) {
                this.setState({
                    loading: false,
                    showAlert: true,
                    alertMsg: "Error reserving box job. " + result.error
                })
            } else {
                this.setState({
                    loading: false,
                    showAlert: false,
                    alertMsg: "",
                    readyToOrder: false,
                    showSuccess: true,
                    formSubmitted: true,
                    successMsg: "This Box Job Template is reserved and will be created automatically when your order is placed and box job is processed."
                })
            }
        }).catch((error) => {
            this.setState({
                loading: false,
                showAlert: true,
                alertMsg: "Error reserving box job. " + error.message
            })
        })
    }

    reserveBoxConfigurationWithOrder = async (orderNumber) => {
        // Reserve with a specific order number
        let token = JSON.parse(localStorage.getItem("token"));
        this.os.reserveBoxConfiguration(token, this.state.box_configuration.id, this.state.qty, orderNumber).then((result) => {
            if (result.error) {
                this.setState({
                    loading: false,
                    showAlert: true,
                    alertMsg: "Error reserving box job. " + result.error
                })
            } else {
                this.setState({
                    loading: false,
                    showAlert: false,
                    alertMsg: "",
                    readyToOrder: false,
                    showSuccess: true,
                    formSubmitted: true,
                    successMsg: result.message || `Box Job reserved for Order #${orderNumber}. It will be created automatically when the order is processed.`
                })
            }
        }).catch((error) => {
            this.setState({
                loading: false,
                showAlert: true,
                alertMsg: "Error reserving box job. " + error.message
            })
        })
    }

    setAppliedOrder = (order_number) => {
        this.setState({openOrderModal: true});
        this.getValidation(this.state.qty, order_number);
    }

    toggleOrderModal = () => {
        this.setState({openOrderModal: !this.state.openOrderModal})
    }

    openApplyOrderModal = (order) => {
        this.setState({
            openApplyOrderModal: true,
            selectedOrder: order,
            applyOrderQty: 1,
            applyOrderError: "",
            applyOrderSuccess: false
        });
    }

    toggleApplyOrderModal = () => {
        this.setState({
            openApplyOrderModal: !this.state.openApplyOrderModal,
            selectedOrder: null,
            applyOrderQty: 1,
            applyOrderError: "",
            applyOrderSuccess: false
        });
    }

    handleApplyOrderQtyChange = (e) => {
        this.setState({ applyOrderQty: parseInt(e.target.value) || 1 });
    }

    getMaxQuantityForOrder = (order) => {
        if (!order || !order.required_products) return 1;

        const maxQtys = order.required_products.filter(item => !item.is_placeholder).map(item => {
            if (item.available_qty === 0) return 0;
            return Math.floor(item.available_qty / (item.required_qty || 1));
        });

        return Math.max(1, Math.min(...maxQtys));
    }

    submitApplyOrder = () => {
        if (this.state.selectedOrder) {
            this.applyOrder(this.state.selectedOrder.order_number, this.state.applyOrderQty);
        }
    }

    render() {
        return  (
            <div>
                { this.state.box_configuration  && (
                <Row key={"boxConfigRow" + this.state.box_configuration.id } className={ this.state.box_configuration.has_order ? "bg-warning" : "border-bottom" }>
                    <Col className="col" md={2}>
                        <div><strong>{this.state.box_configuration.name }</strong></div>
                    </Col>
                    <Col className="col" md={5}>
                        {this.state.box_configuration.product && (
                            <div>
                                {this.state.box_configuration.product.small_image_url && (
                                    <div className='float-left mr-4'>
                                        <img src={this.state.box_configuration.product.small_image_url} className="mx-1 w-100" style={{maxWidth: "60px"}} alt={this.state.box_configuration.name} />
                                    </div>
                                )}
                                <div>{this.state.box_configuration.product.sku} { this.state.box_configuration.product.name }</div>
                                <div>{this.state.box_configuration.enclosure_type} {this.state.box_configuration.powder_color}</div>
                            </div>
                        )}
                        <div className='clearfix'>
                            {this.state.box_configuration.required_products && this.state.box_configuration.required_products.length > 0 && (
                                <div className="mt-2">
                                    <span
                                        style={{ cursor: 'pointer', fontSize: '0.85rem', color: '#007bff' }}
                                        onClick={() => this.setState({ showRequiredProducts: !this.state.showRequiredProducts })}
                                    >
                                        {this.state.showRequiredProducts ? '▼' : '▶'} Products ({this.state.box_configuration.required_products.filter(p => !p.is_placeholder).length})
                                    </span>
                                    <Collapse isOpen={this.state.showRequiredProducts}>
                                        <div className="mt-1 pl-2" style={{ fontSize: '0.85rem' }}>
                                            {this.state.box_configuration.required_products
                                                .filter(product => !product.is_placeholder)
                                                .map((product, index) => (
                                                <div key={`required-product-${index}`} className="text-muted mb-1">
                                                    <div>
                                                        <strong>{product.sku}</strong>
                                                        <span style={{ fontSize: '0.8rem' }}> - {product.product_name || product.name}</span>
                                                        <span> x {product.qty || 1}</span>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </Collapse>
                                </div>
                            )}
                        </div>
                        <div className='clearfix'>
                            {this.state.box_configuration.reserved_configurations.length > 0 && (
                                <div className='alert alert-secondary mx-0 py-1'>
                                    <h6 className='row p-1 bg-warning text-white mb-1'>Reserved Box Jobs:</h6>
                                    <BoxConfigurationReservation reservedConfigurations={this.state.box_configuration.reserved_configurations} boxConfigurationId={this.state.box_configuration.id} />
                                </div>
                            )}
                            {this.state.orders_needing_items.length > 0 && (
                                <div className='alert alert-warning m-0 py-1'>
                                    <h4>Orders Requiring Items</h4>
                                    {this.state.orders_needing_items.map((order) => (
                                        <div className='clearfix' key={"boxConfigOrder" + this.state.box_configuration.id + "-" + order.id}>
                                            <div>
                                                <div className='float-right'>
                                                    <Button color="warning" size="sm" className="my-1" onClick={() => this.setAppliedOrder(order.order_number)}>Add to this Order</Button>
                                                </div>
                                                <div className='float-left'>
                                                    <div>Order#: <b>{order.order_number}</b></div>
                                                    {order.required_products.map((item) => (
                                                        (item.is_placeholder !== true && (
                                                        <div key={"boxConfigOrderItem" + this.state.box_configuration.id + "-" + order.id + "-" + item.sku}>
                                                            {item.sku} - {item.available_qty} available
                                                        </div>
                                                        ))
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            )}
                            {this.state.box_configuration.box_configuration_orders.length > 0 && (
                                <div className='alert alert-warning m-0 py-1 clearfix'>
                                    <b>Pending Orders</b>
                                    {this.state.box_configuration.box_configuration_orders.map((box_order) => (
                                        <div key={"boxOrder" + this.state.box_configuration.id + "-" + box_order.id}>
                                            {box_order.order_number && (
                                                <div>Order#: <b>{box_order.order_number}</b></div>
                                            )}
                                            {box_order.box_job_id && (
                                                <div>Box Job#: <b>{box_order.box_job_id}</b></div>
                                            )}
                                            {box_order.received_date && (
                                                <div>Date Started: <b>{box_order.received_date}</b> </div>
                                            )}
                                            {box_order.status && (
                                                <div>Status: <b>{box_order.status}</b></div>
                                            )}
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    </Col>
                    <Col className="col" md={2}>
                        <b>{moment(this.state.box_configuration.created_at).format("MMM DD YYYY h:mm A") }</b>
                    </Col>
                    <Col className="col" md={1}>
                        {/* Quick Order disabled - using batch Create Order instead
                        <Button color="success" size="sm" block className="my-1 px-0" onClick={() => this.setState({openOrderModal: !this.state.openOrderModal})}>Quick Order</Button>
                        */}
                        <QuickOrderModal
                            isOpen={this.state.openOrderModal}
                            toggle={this.toggleOrderModal}
                            boxConfiguration={this.state.box_configuration}
                            qty={this.state.qty}
                            onQtyChange={this.checkQty}
                            separateProducts={this.state.separateProducts}
                            onSeparateProductsChange={() => this.setState({separateProducts: !this.state.separateProducts})}
                            showAlert={this.state.showAlert}
                            alertMsg={this.state.alertMsg}
                            showSuccess={this.state.showSuccess}
                            successMsg={this.state.successMsg}
                            showWarning={this.state.showWarning}
                            warningMsg={this.state.warningMsg}
                            formSubmitted={this.state.formSubmitted}
                            onReserve={this.reserveBoxConfiguration}
                            availableOrders={this.state.available_orders}
                            onReserveWithOrder={this.reserveBoxConfigurationWithOrder}
                            quickOrderFormLabel="OR Use Quick Order Form"
                            // requiredDrillHoles={this.state.box_configuration.required_drill_holes || 0}
                        />
                        <a href={"/box-configurations?id=" + this.state.box_configuration.id} className="btn btn-outline-primary btn-sm">Edit</a>
                    </Col>

                    <Modal style={{top: '60px'}} isOpen={this.state.openApplyOrderModal} toggle={this.toggleApplyOrderModal}>
                        <ModalHeader toggle={this.toggleApplyOrderModal}>
                            Apply Template to Order {this.state.selectedOrder?.order_number}
                        </ModalHeader>
                        <ModalBody>
                            {this.state.selectedOrder && (
                                <div>
                                    <Form>
                                        <FormGroup>
                                            <Label for="applyOrderQty">Quantity</Label>
                                            <Input
                                                name="applyOrderQty"
                                                id="applyOrderQty"
                                                type="number"
                                                min="1"
                                                max={this.getMaxQuantityForOrder(this.state.selectedOrder)}
                                                value={this.state.applyOrderQty}
                                                onChange={this.handleApplyOrderQtyChange}
                                            />
                                            <small className="text-muted">
                                                Maximum: {this.getMaxQuantityForOrder(this.state.selectedOrder)} (based on available inventory)
                                            </small>
                                        </FormGroup>
                                    </Form>

                                    <div className="mb-3">
                                        <h6>Products:</h6>
                                        {this.state.selectedOrder.required_products
                                            .filter(item => !item.is_placeholder)
                                            .map((item) => (
                                            <div key={item.sku} className="small">
                                                {item.sku} - Need: {(item.required_qty || 1) * this.state.applyOrderQty}, Available: {item.available_qty}
                                            </div>
                                        ))}
                                    </div>

                                    {this.state.applyOrderError && (
                                        <Alert color="danger">{this.state.applyOrderError}</Alert>
                                    )}

                                    {this.state.applyOrderSuccess && (
                                        <Alert color="success">Box job created successfully! Reloading page...</Alert>
                                    )}
                                </div>
                            )}
                        </ModalBody>
                        <ModalFooter>
                            <Button
                                color="primary"
                                onClick={this.submitApplyOrder}
                                disabled={this.state.applyOrderSuccess || this.state.applyOrderQty > this.getMaxQuantityForOrder(this.state.selectedOrder)}
                            >
                                Apply Template
                            </Button>
                            <Button color="secondary" onClick={this.toggleApplyOrderModal}>
                                Cancel
                            </Button>
                        </ModalFooter>
                    </Modal>
                </Row>
                )}


            </div>
        )
    }
}
export default BoxConfiguration;